import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next";

interface ShippingServiceProps extends AutoCompleteProps {
  shippingAgentCode?: string | null;
}

const ShippingServiceAutoComplete: React.FC<ShippingServiceProps> = ({
  onChange,
  valueId,
  label,
  load = true,
  disabled = false,
  infoText,
  error,
  helperText,
  shippingAgentCode,
}) => {
  const { t } = useTranslation();
  const url = `/autocompleteApi/ShippingService?shippingAgentCode=${shippingAgentCode ?? ""}&`;

  return (
    <AsyncAutoCompleteContained
      key={shippingAgentCode ?? "none"}
      label={label ?? t("common.shippingService")}
      url={url}
      valueId={valueId}
      load={load && !!shippingAgentCode}
      onChange={onChange}
      disabled={disabled || !shippingAgentCode}
      infoText={infoText}
      error={error}
      helperText={helperText}
    />
  );
};

export default ShippingServiceAutoComplete;
